document.addEventListener('DOMContentLoaded', function () {
    var swiper = new Swiper('#container-before-after.swiper-container', {
        loop: true,
      allowTouchMove: true,
        autoplay: {
          delay: 5000,
        },
        pagination: {
            el: '.swiper-pagination', // Updated with '-befAfter'
            clickable: true,
        },
    });
});
